import script from "./Slide.vue?vue&type=script&setup=true&lang=js"
export * from "./Slide.vue?vue&type=script&setup=true&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=9dcd66b6&lang=css"

const __exports__ = script;

export default __exports__